import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ContractAgreementSchema } from '../types';
import { ContractWithBookingInfo } from 'entities/Contract';

const initialState: ContractAgreementSchema = {
  contract: null,
};

const reducer = createSlice({
  name: 'contractAgreementModal',
  initialState,
  reducers: {
    openContractAgreementModal: (state: ContractAgreementSchema, action: PayloadAction<Nullable<ContractWithBookingInfo>>) => {
      state.contract = action.payload;
    },
    clearContractAgreementModal: (state: ContractAgreementSchema) => {
      state.contract = null;
    },
  },
});

export const { actions: contractAgreementModalActions, reducer: contractAgreementModalReducer } = reducer;
